module.exports = __webpack_public_path__ + "img/ex4.2f707339.png";